import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import '../../styles/StudentComponents/SignupSection.css';
import { FaQuoteLeft } from 'react-icons/fa';

const SignupSection = ({
  heading = "What our customers say",
  subheading = "Strawket is making learning personalized and impactful!",
}) => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  const REPO = process.env.REACT_APP_CONTENT_REPO;
  const BRANCH = process.env.REACT_APP_CONTENT_BRANCH;

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const res = await axios.get(
          `https://api.github.com/repos/${REPO}/contents/tests?ref=${BRANCH}`
        );

        const files = res.data.filter((file) => file.name.endsWith('.md'));

        const fetchEach = async (file) => {
          try {
            const contentRes = await axios.get(file.download_url);
            const content = contentRes.data;
            const frontmatterMatch = content.match(/---\n([\s\S]*?)\n---/);
            const message = content.replace(/---\n([\s\S]*?)\n---/, '').trim();

            if (!frontmatterMatch) return null;

            const frontmatterLines = frontmatterMatch[1].split('\n');
            const data = {};
            frontmatterLines.forEach((line) => {
              const [key, ...rest] = line.split(':');
              data[key.trim()] = rest.join(':').trim().replace(/^"|"$/g, '');
            });

            if (data.role !== 'student') return null;

            let profileImageUrl = null;
            if (data.profile) {
              profileImageUrl = `https://raw.githubusercontent.com/${REPO}/${BRANCH}/images/${data.profile}`;
            }

            return { ...data, message, profile: profileImageUrl };
          } catch (err) {
            console.error('❌ Error fetching testimonial:', err);
            return null;
          }
        };

        const rawData = await Promise.all(files.map(fetchEach));
        const validTestimonials = rawData.filter(Boolean);
        setTestimonials(validTestimonials);
      } catch (err) {
        console.error('Error fetching testimonials:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchTestimonials();
  }, []);

  return (
    <section className="signup-container">
      <div className="testimonial-heading4">
        <h2>{heading}</h2>
        <p>{subheading}</p>
      </div>
      <div className="testimonial-carousel-wrapper">
      <Swiper
  slidesPerView={1}
  spaceBetween={20}
  pagination={{ clickable: true }}
  grabCursor={true}
  modules={[Pagination]}
>

  

          {testimonials.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="testimonial-card2">
                <p className="quote"><FaQuoteLeft /></p>
                <p className="testimonial-text">{item.message}</p>
                <div className="user-info">
                  <div className="user-avatar">
                    <img
                      src={item.profile || require('../../assets/Images/avatar.jpeg')}
                      alt={item.name}
                      style={{ borderRadius: '50%', width: '100%', height: '100%' }}
                    />
                  </div>
                  <h4>{item.name}</h4>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* <div className="signup-box">
        <h2>Sign<span> Up </span></h2>
        <p>Join us today and get started!</p>
        <form className="signup-form">
          <div className="form-group">
            <label htmlFor="name">Name*</label>
            <input type="text" id="name" name="name" placeholder="Enter your name" required />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email*</label>
            <input type="email" id="email" name="email" placeholder="Enter your email" required />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password*</label>
            <input type="password" id="password" name="password" placeholder="Enter your password" required />
          </div>

          <div className="form-footer">
            <a href="#">Forgot Your Password?</a>
          </div>

          <button type="submit" className="login-btn8">Login</button>
          <button type="button" className="google-btn">
            <span className="g-icon">G</span> Login With Google
          </button>
        </form>
      </div> */}
    </section>
  );
};

export default SignupSection;